/* Add lightbox to gallery and feature images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img, .gh-feature-image'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Keep the active category pill visible when the row scrolls on mobile */
(function () {
    const active = document.querySelector('.gh-pill.is-active');
    if (!active) return;

    const row = active.parentElement;
    if (row.scrollWidth > row.clientWidth) {
        row.scrollLeft = active.offsetLeft - (row.clientWidth - active.offsetWidth) / 2;
    }
})();

/* Featured posts carousel */
(function () {
    carousel();
})();

/* Numbered pagination */
(function () {
    pagination();
})();

/* Listen to the article with the browser's text-to-speech */
(function () {
    listen();
})();

/* Share buttons */
(function () {
    share();
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');

    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();
